import * as Joi from "joi";
import { Column, PrimaryGeneratedColumn } from 'typeorm';
import Base from './base.entity';

export default abstract class UserBase extends Base {
	static readonly skipUpdateColumns = ['id'];

	@PrimaryGeneratedColumn()
	id: number;

	@Column('int')
	last_updated_user: number;

	@Column('int')
	created_by: number;

	static rules() {
		return {
			...super.rules(),
			last_updated_user: Joi.number().integer().allow(null),
			created_by: Joi.number().integer(),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			last_updated_user: this.last_updated_user,
			created_by: this.created_by,
		};
	}
}
